<div class="container-fluid" [ngClass]="A04CDE== null ? 'advanced-mt-4' : 'advanced-mt-0'">

	<!-- MODAL -->
	<ng-template #contenido let-modal>
		<div class="modal-header">
		<h4 class="modal-title"></h4>
		<button type="button" class="btn-close btn-rounded " data-bs-dismiss="modal" aria-label="Close"
			(click)="modal.dismiss()"></button>
		</div>
		<div class="modal-body" style="padding-top: 0px;padding-bottom: 0px;">
		<app-advancedtable [WsURL]=strWsURLModal [WsLlaves]=WsLlavesModal (RetornoModal)=RetornoModalLista($event)
			[mostrarModal]=true>
		</app-advancedtable>
		<div *ngIf="currentPDF">
			<object [data]="getSafeUrl()" type="application/pdf" width="100%" height="600px">
			</object>
		</div>
		</div>
	</ng-template>
	<!-- END MODAL -->

	<!-- BEGIN Mantenimiento Interno -->
	<div *ngIf="this.MsDetalle=='S' && this.WsMsDataInterno != '' ">
		<app-simple-ms [WsData]=this.WsMsDataInterno (CerrarMsInterno)="EventoCerrarMSInterno($event)"></app-simple-ms>
	</div>
	<!-- END Mantenimiento Interno -->

	<!-- BEGIN Toolbar -->

	<div class="row mb-3" *ngIf="this.WsMsDataInterno == ''">
		<div class="col-md-12">
		<div class="card mb-0" style="background-color: transparent;">
			<div class="card-body" style="padding: 0.5em;">
			<div class="row align-items-center">
				<div class="col-md-6 col-sm-12">
				<ng-container *ngIf="!this.mostrarbreitem">
					<ng-container *ngIf="A04CDE==null; else wizard">
					<div style="padding-left: 1em" class="mb-1">
						<h4 class="mb-0 letra-azul">{{TituloPantalla}}</h4>
						<ol class="breadcrumb m-0" style="padding: 0">
						<li class="breadcrumb-item"><b>Compa&ntilde;&iacute;a:</b> {{companiaActual}}</li>
						<li class="breadcrumb-item"><b>Sede:</b> {{sedeActual}}</li>
						</ol>
					</div>
					</ng-container>
					<ng-template #wizard>
					<ol class="breadcrumb m-0">
						<li class="breadcrumb-item">{{TituloPantalla}}</li>
						<li class="breadcrumb-item active"><b>{{A04CDE}}</b></li>
					</ol>
					</ng-template>
				</ng-container>
				<div class="page-title-right" *ngIf="this.mostrarbreitem">
					<ol class="breadcrumb m-0">
					<li class="breadcrumb-item active"><b>{{this.TituloPantalla}} </b></li>
					</ol>
				</div>
				</div>
				<div class="col-md-6 col-sm-12" style="text-align: end">

				<ng-container *ngIf="this.toolbarResp">
				<div  class="d-inline-block bloque mb-1" *ngFor="let boton of this.toolbarResp[0].NORMALES">
					<div ngbDropdown class="d-inline-block" *ngIf="boton.Evento == 'IMPRIMIR';else otrosBotones">
						<button type="button" title="{{boton.Tooltip}}" id="{{boton.Evento}}" name="{{boton.Evento}}"
						class="btn blanco btn-label waves-light" ngbDropdownToggle
						[ngStyle]="{'background-color': boton.class }">
						<i class="fas fa-print label-icon" style="pointer-events:none ;"></i>
						{{boton.boton}}
						</button>
					</div>

					<ng-template #otrosBotones>

						<button type="button"  title="{{boton.Tooltip}}" id="{{boton.Evento}}" name="{{boton.Evento}}"
						(click)="EventoClickToolbar($event, boton.URL)" class="btn blanco btn-label waves-light"
						[ngStyle]="{'background-color': boton.class }">
						<i class="fas {{boton.icono}} label-icon" style="pointer-events:none ;"></i>
						{{boton.boton}}
						</button>
					</ng-template>
				</div>

				<!--Operaciones Especiales -->
				<div class="d-inline-block bloque mb-1" *ngIf="!mostrarModal">
					<div ngbDropdown class="d-inline-block" *ngIf="this.toolbarResp[0].OPERACIONES.length > 0">
						<button type="button" title="Procesos"
						class="btn blanco btn-label waves-light" ngbDropdownToggle
						[ngStyle]="{'background-color': '#db5800' }">
						<i class="fas fa-solid fa-ellipsis-vertical label-icon"  style="pointer-events:none ;"></i>
						Procesos
						</button>
						<div ngbDropdownMenu >
							<ng-container *ngFor="let OPERACIONES of this.toolbarResp[0].OPERACIONES">
							<button *ngIf="OPERACIONES"  ngbDropdownItem (click)="EventoClickToolbar($event, OPERACIONES.URL)"
							id="{{OPERACIONES.Evento}}" name="{{OPERACIONES.Evento}}"> {{OPERACIONES.boton}}</button>
							</ng-container>

						</div>
					</div>
				</div>

				<div class="d-inline-block bloque mb1" *ngIf="!mostrarModal && reportes.length > 0">
					<button *ngIf="this.tipo_pantalla !== 'REPORTE'" style="background-color: #86aec4; color: white;"
					  type="button" title="Filtrar" (click)="open()" class="btn btn-label waves-light">
					  <i class="fas fa-print label-icon" style="pointer-events:none; "></i>
					  Reportes
					</button>
				  </div>

				</ng-container>
					<!-- Se comenta por activación pantalla principal -->
					<!-- <div class="d-inline-block bloque mb1" *ngIf="!mostrarModal && respFiltros.length > 0">
						<button *ngIf="this.tipo_pantalla !== 'REPORTE'" type="button" title="Filtrar" (click)="open()" class="btn btn-info btn-label waves-light">
						<i class="fas fa-filter label-icon" style="pointer-events:none ;"></i>
						Filtrar
						</button>
					</div> -->
				</div>
				</div>
			</div>
		</div>
		<!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
		<!-- <hr class="mt-1" style="border-top: 6px solid var(--app-oscuro, #0c7cb3);"> -->
		</div>


	</div>
	<!-- END Toolbar -->

	<div class="row mb-3" *ngIf="mostrarModal && ActivarFiltro=='S'">
		<div class="col-md-12" *ngIf="form_template$">
		<!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
		<div class="card mb-0" style="background-color: var(--app-muy-claro, #edf4f9);box-shadow: 0px 3px 8px;">
			<div class="card-body">
			<app-filtrocampo [form_template]="form_template$  | async" [strListener]="strEventListener"
				[blnMostrarBusqueda]="true && tipo_pantalla!='REPORTE'" [TipoPantalla]="tipo_pantalla" [MostrarbotonBuscar]="'true'"
				[Mostrartitulofiltro]="Mostrartitulofiltro" (cerrar)="cerrarmodal($event)">
			</app-filtrocampo>
			</div>
		</div>
		</div>
	</div>

  	<app-alerta [SYS41ARC]="this.SYS41ARC"></app-alerta>

	  <ng-container *ngIf="respFiltros.length > 0 && this.WsMsDataInterno == ''">
		<div ngbAccordion *ngIf="respFiltros[0].FiltrosAvanzado.length > 0" class="filtros-accordion mb-3">
			<div ngbAccordionItem>
	
				<!-- Header -->
				<h6 ngbAccordionHeader class="filtros-header">
					<button ngbAccordionButton class="filtros-toggle">
						<div class="d-flex align-items-center gap-2">
							<span class="filtros-icon-wrap">
								<i class="fa fa-sliders-h"></i>
							</span>
							<span class="filtros-label">Filtros Avanzados</span>
						</div>
						<i class="fa fa-chevron-down filtros-chevron"></i>
					</button>
				</h6>
	
				<!-- Body -->
				<div ngbAccordionCollapse>
					<div ngbAccordionBody class="filtros-body">
						<ng-template>
							<div class="row mb-0">
								<div class="col-md-12">
									<app-filtrocampo 
										[form_template]="respFiltros"
										[blnAccionbuscar]="blnAccionbuscar"
										[strListener]="strEventListener"
										[blnMostrarBusqueda]="true"
										[TipoPantalla]="tipo_pantalla"
										[formFiltros]="formFiltros"
										[FiltrosAvan]="1"
										[Mostrartitulofiltro]="Mostrartitulofiltro">
									</app-filtrocampo>
								</div>
							</div>
						</ng-template>
					</div>
				</div>
	
			</div>
		</div>
	</ng-container>

	<div class="row" *ngIf="safeURL">
		<iframe [src]="safeURL" width="0px" height="0px" style='display:hidden'>
		</iframe>
	</div>

	<div class="row mt-4" *ngIf="this.WsMsDataInterno == ''">
		<div [ngClass]="blnFiltrosAbiertos ? 'col-9' : 'col-12'" style="margin-bottom: -25px;">
			<div class="card" style="background-color: transparent; box-shadow: none;" *ngIf="this.tipo_pantalla !='REPORTE'">
				<div class="card-body" style="padding: 0">
				<div class="row">
					<div class="col-md-12 " *ngIf="this.tipo_pantalla=='LISTADO' ">
						<div class="row align-items-center" *ngIf="!mostrarModal">
							<div style="text-align: right;" class="offset-6 col-6">
								<button *ngIf="this.EsExterna == true" type="button" [ngClass]="this.favorito_pantalla == 'N' ? 'btn btn-light btn-label waves-light' : 'btn btn-warning btn-label waves-light' "
									(click)="GrabarFavorito()" title="Favoritos">
									<i [ngClass]="this.favorito_pantalla == 'N' ? 'far fa-star label-icon ' : 'fas fa-star label-icon ' "></i>Favoritos
								</button> 
								<button type='button'  style="margin-left: 0.5em;" class="btn btn-info btn-label waves-light" (click)="BuscarAvanzado()" title="Buscar">
									<i class="fa fa-search label-icon" ></i> Buscar
								</button>
								<button type="button" style="margin-left: 0.5em;" class="btn btn-info btn-label waves-light" (click)="limpiarbusqueda()" title="Limpiar">
									<i class="fa fa-broom label-icon"></i> Limpiar
								</button>
								<button *ngIf="this.SYS02TUT != '' && this.EsExterna == true" type='button'  style="margin-left: 0.5em;" class="btn btn-info btn-label waves-light" (click)="abrirAyuda()" title="Tutorial">
									<i class="fa fa-file-circle-question label-icon" ></i> Tutorial
								</button>
							</div>
						</div>
					<br>
					</div>
				</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row" *ngIf="this.WsMsDataInterno == ''">
		<div class="col-lg-12">
			<ejs-grid *ngIf="columnas.length > 0" 	
				#ListaEditableSync id='ListaEditableSync' 
				[dataSource]='tableData2'
				[allowSorting]='true' 
				[allowFiltering]='true' 
				[filterSettings]='filterSettings'
				[editSettings]='editSettings'
				(actionBegin)='actionBegin($event)'
				(actionComplete)='actionComplete($event)'
				[allowResizing]='true' 
				width='100%'
				height='auto'
				(load)='load()'
				[allowGrouping]="true" 
				[groupSettings]="groupOptions"
				[allowPaging]="true"
				[pageSettings]="pageSettings">
				
				<e-columns>		
					<e-column *ngFor="let columna of columnas" 
						[field]="columna.A03COD" 
						[headerText]="columna.A03DES"	
						[type]="columna.TIPO"	
						[format]="columna.FORMATO == 'N' ? 'n2' : columna.FORMATO"
						[editType]="columna.EDITTYPE" 
						[allowEditing]="columna.EDITABLE === 'S'"
						[width]="columna.WIDTH || 125" 
						headerClass="column-header" 
						cellClass="column-cell"
						[validationRules]="columna.REGLA"
						locale='es'
						[clipMode]="'EllipsisWithTooltip'">	
					</e-column> 
					<e-column [visible]="tieneAcciones" headerText="Acciones" textAlign="Center" [width]="anchoAcciones">
						<ng-template #template let-data>
							<div class="d-flex justify-content-center">
								<ng-container *ngFor="let operacionbutton of operaciones; let i=index">
									<button type="button" 
										*ngIf="operacionbutton.SYS16MET=='S'"
										[title]="operacionbutton.boton"
										(click)="EventoClickOperacion(operacionbutton, data.INDEX, i)" 
										[id]="data.INDEX"
										class="btn-accion-nuevo"
										[ngStyle]="{'background-color': operacionbutton.class}">
										<i class="fas {{operacionbutton.icono}}"></i>
									</button>
								</ng-container>
							</div>
						</ng-template>
					</e-column>
				</e-columns>
					<e-aggregates>
						<e-aggregate>
							<e-columns>
								<ng-container *ngFor="let columna of columnas">
									<e-column *ngIf="columna.OPERACION !== ''"
										[field]="columna.A03COD" 
										[format]="columna.FORMATO == 'N' ? 'n2' : columna.FORMATO"
										[type]="columna.OPERACION" 
									>
										<ng-template *ngIf="columna.OPERACION === 'sum'" #footerTemplate let-data>Total: {{data.sum}}</ng-template>
										<ng-template *ngIf="columna.OPERACION === 'Avg'" #footerTemplate let-data>Promedio: {{data.average}}</ng-template>
										<ng-template *ngIf="columna.OPERACION === 'count'" #footerTemplate let-data>Conteo: {{data.count}}</ng-template>
										<ng-template *ngIf="columna.OPERACION === 'DistinctCount'" #footerTemplate let-data>Conteo Distinto: {{data.distinctCount}}</ng-template>
										<ng-template *ngIf="columna.OPERACION === 'max'" #footerTemplate let-data>Máximo: {{data.max}}</ng-template>
										<ng-template *ngIf="columna.OPERACION === 'min'" #footerTemplate let-data>Mínimo: {{data.min}}</ng-template>
										<ng-template *ngIf="columna.OPERACION === 'product'" #footerTemplate let-data>Producto: {{data.product}}</ng-template>
										<ng-template *ngIf="columna.OPERACION === 'median'" #footerTemplate let-data>Mediana: {{data.median}}</ng-template>
										
										<ng-template *ngIf="columna.OPERACION === 'sum'" #groupFooterTemplate let-data>
											Subtotal: {{data.sum}}
										</ng-template>
									</e-column>
								</ng-container>  
							</e-columns>
						</e-aggregate>
					</e-aggregates>
			</ejs-grid>
		</div>
	</div>
	<div class="row" *ngIf="this.WsMsDataInterno == ''">
		<div class="col-lg-12 d-flex justify-content-between align-items-center">
		  <label class="table__label">[{{this.intSYS02CON}}] Backend {{ this.TiempoBackend }} Front {{ DiferenciaTiempo() }}</label>
		  <div class="dataTables_length">
			<label class="d-inline-flex align-items-center">Mostrando
			  <select class="form-select mx-2" style="width:55px;" (change)="clickHandler($event.target.value)">
				<option *ngFor="let number of number" [selected]="number === itemsPerPage">{{number}}</option>
			  </select>
			  Registros
			</label>
		  </div>
		</div>
	  </div>
</div>
